var version = {
    "name":      "dativery",
    "buildDateCode": "20260617-140754",
    "buildDate": "Wed Jun 17 2026 14:07:54 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260617-140754",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;